import { InternalId, Uuid } from '@edgebox/data-definition-kit';
import { ClientRemoteEntityCloneEntity } from '@edgebox/sync-core-rest-client';
import React from 'react';
import { Table } from '@edgebox/react-components';
import { listEntities } from '../frame-messages';
import { ISyncCoreApiComponentState, SyncCoreApiComponent } from '../services/SyncCoreApiComponent';
import { PagedList } from './PagedList';
import { RemoteEntityCloneListItem } from './RemoteEntityCloneListItem';
import { resolveEntityName } from './SiteEntityName';

export interface IRemoteEntityCloneListFilters {
  siteId?: InternalId;
  sourceRemoteUuid?: Uuid;
  targetRemoteUuid?: Uuid;
  sourceRemoteUniqueId?: string;
  targetRemoteUniqueId?: string;
}

interface IProps {
  filters: IRemoteEntityCloneListFilters;
  pageSize?: number;
}

export class RemoteEntityCloneList extends SyncCoreApiComponent<IProps, ISyncCoreApiComponentState> {
  async load() {
    return {};
  }

  render() {
    const { filters, pageSize = 5 } = this.props;

    return (
      <PagedList<ClientRemoteEntityCloneEntity, any>
        defaultNumberOfItemsPerPage={pageSize}
        noPagerIfNotNeeded
        initialFilters={filters}
        request={(page, f, itemsPerPage) =>
          this.api.syndication.remoteEntityClones.list(
            {
              siteId: f?.siteId,
              sourceRemoteUuid: f?.sourceRemoteUuid,
              targetRemoteUuid: f?.targetRemoteUuid,
              sourceRemoteUniqueId: f?.sourceRemoteUniqueId,
              targetRemoteUniqueId: f?.targetRemoteUniqueId,
            },
            { page, itemsPerPage: itemsPerPage || pageSize }
          )
        }
        emptyMessage={<span className="text-muted">No clones found.</span>}
        renderList={(items) => (
          <Table responsive size="sm" className="mb-0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Pulled</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>{items}</tbody>
          </Table>
        )}
        renderItem={(clone) => <RemoteEntityCloneListItem clone={clone} />}
      />
    );
  }
}

// Re-export helper calls so other components can reuse the same approach.
export { listEntities, resolveEntityName };
